import React, { useState } from 'react';
import {
  FAQContainer,
  AccordionItem,
  QuestionRow,
  QuestionText,
  PlusIcon,
  Answer,
} from './accordion.styles';

const faqData = [
  // Learner FAQs
  {
    type: 'learner',
    question: 'What is Motivar?',
    answer: "Motivar provides learner-support services for online learning. We help users find, start, and complete online courses they need to upskill. It also facilitates a sponsorship system where individuals or groups can fund a learner's educational journey.",
  },
  {
    type: 'learner',
    question: 'How does Motivar help me find courses?',
    answer: 'Our AI agent, Moji, assesses your skills and aspirations to match you with the best online courses from across the web that fit your budget and schedule.',
  },
  {
    type: 'learner',
    question: 'Can I request help to fund a course?',
    answer: 'Yes. If you find a course you cannot afford, you can submit a sponsorship request through the platform to be connected with potential donors.',
  },
  {
    type: 'learner',
    question: 'What information is required to request help?',
    answer: 'You will need to provide details about the course, its cost, and a brief explanation of how it aligns with your career advancement.',
  },
  {
    type: 'learner',
    question: 'What if I do not know which course to take?',
    answer: 'You can chat with Moji, who will help define your career path and recommend specific courses based on current industry demands.',
  },

  // Sponsor FAQs
  {
    type: 'sponsor',
    question: 'How do I become a sponsor on Motivar?',
    answer: 'You can sign up as a sponsor to browse verified learner requests and choose specific individuals or cohorts to fund.',
  },
  {
    type: 'sponsor',
    question: 'What information can I see about a learner?',
    answer: "Sponsors can view the learner's career goals, the specific course requested, the funding amount needed, and their progress updates once sponsored.",
  },
  {
    type: 'sponsor',
    question: 'How do I track my sponsored requests?',
    answer: 'Your sponsor dashboard provides real-time visibility into the total amount spent, the number of learners supported, and their course completion status.',
  },
  {
    type: 'sponsor',
    question: 'Is my sponsorship reflective of a specific currency?',
    answer: 'Yes, the dashboard will reflect the currency set in your sponsor profile to ensure accurate tracking of your contributions. You can update anytime.',
  },
  {
    type: 'sponsor',
    question: 'How does my support impact learners?',
    answer: 'Your funding directly removes the financial barrier to education, allowing learners to gain the digital skills needed for employment and career growth.',
  },
];

const Accordion = ({ activeTab = 'learner' }) => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleIndex = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const filteredFaqs = faqData.filter(faq => faq.type === activeTab);

  return (
    <FAQContainer>

      {filteredFaqs.map((item, index) => (
        <AccordionItem key={index} onClick={() => toggleIndex(index)}>
          <QuestionRow>
            <QuestionText>{item.question}</QuestionText>
            <PlusIcon isOpen={openIndex === index}>+</PlusIcon>
          </QuestionRow>
          {openIndex === index && <Answer>{item.answer}</Answer>}
        </AccordionItem>
      ))}
    </FAQContainer>
  );
};

export default Accordion;
